<template>
  <div class="mini_program_body">
    <custom-component></custom-component>
  </div>
</template>

<script>
import customComponent from "./components/customComponent/index";
export default {
  data() {
    return {
      
    };
  },
  created() {},
  methods: {},
  components: {
    customComponent,
  },
};
</script>